export const tooltipTexts: any = {
  'N/A': {
    text: 'N/A - Not Available',
    iconClass: 'stop-grey-icon',
    errorIconClass: 'stop-red-icon',
  },
  'N/R': {
    text: 'N/R - Not Required',
    iconClass: 'stop-grey-icon',
    errorIconClass: 'stop-red-icon',
  },
  'U/K': {
    text: 'U/K - Unkown',
    iconClass: 'stop-grey-icon',
    errorIconClass: 'stop-red-icon',
  },
};
